const normalizeSearch = (value: string) => value.trim().replace(/\s+/g, ' ').toLowerCase()

export function matchesUserSearch(
  user: { first_name?: string | null; last_name?: string | null },
  groupName: string,
  query: string
): boolean {
  const search = normalizeSearch(query)
  const fullName = normalizeSearch([user.first_name, user.last_name].filter(Boolean).join(' '))
  return fullName.includes(search) || normalizeSearch(groupName).includes(search)
}
